var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 52 52"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 26,
  r: 25,
  fill: "#BCBCBC",
  stroke: "#BCBCBC"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  fillRule: "evenodd",
  d: "M26 1a25 25 0 1 0 0 50 25 25 0 0 0 0-50m0 7.5A8.3 8.3 0 1 1 26 25a8.3 8.3 0 0 1 0-16.5M14 40a18.3 18.3 0 0 0 24 0c.7-.7 1.2-1.7 1.2-2.7 0-4.7-3.8-8.4-8.4-8.4h-9.6a8.3 8.3 0 0 0-8.4 8.4c0 1 .5 2 1.2 2.7",
  clipRule: "evenodd"
})));
export default SvgUser;